import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100 mt-0">
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-16 pb-10">
        <div className="flex flex-col md:flex-row justify-between gap-10 mb-12">
          <div className="md:max-w-xs">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-fire-line text-background-50 text-xl"></i>
              </div>
              <span className="font-heading font-bold text-2xl text-background-50 whitespace-nowrap">
                52吃瓜网
              </span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed">
              每日追踪网红塌房、娱乐圈爆料、黑料八卦，为用户提供吃瓜爆料实时更新与深度追踪。一手吃瓜资讯，尽在52吃瓜网。
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <h4 className="font-heading font-bold text-base text-background-50 mb-4">热门分类</h4>
              <ul className="space-y-2.5">
                {categories.slice(0, 4).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-400 hover:text-accent-400 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="font-heading font-bold text-base text-background-50 mb-4">更多分类</h4>
              <ul className="space-y-2.5">
                {categories.slice(4).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-400 hover:text-accent-400 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
                <li>
                  <Link to="/about" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors">
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-heading font-bold text-base text-background-50 mb-4">联系方式</h4>
              <ul className="space-y-2.5">
                <li className="text-sm text-foreground-400">
                  <i className="ri-mail-line mr-2"></i>hello@rdstudio.cn
                </li>
                <li className="text-sm text-foreground-400">
                  <i className="ri-wechat-line mr-2"></i>52chigua_wechat
                </li>
                <li className="text-sm text-foreground-400">
                  <i className="ri-weibo-line mr-2"></i>@52chigua
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 pt-10">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-6">
            <div className="lg:w-1/3">
              <img
                src="https://readdy.ai/api/search-image?query=A%20stylized%20minimalist%20illustration%20of%20a%20modern%20office%20lounge%20with%20people%20casually%20reading%20news%20on%20their%20phones%2C%20warm%20ambient%20lighting%2C%20editorial%20digital%20art%20style%2C%20relaxed%20social%20atmosphere%2C%20dark%20background%20with%20warm%20accents%2C%20community%20vibe%2C%20cozy%20modern%20interior&width=600&height=300&seq=footer-scene-01&orientation=landscape"
                alt="52吃瓜网社区氛围"
                className="w-full h-40 object-cover rounded-2xl"
                title="52吃瓜网社区"
              />
            </div>

            <div className="lg:w-1/3 flex items-center">
              <div>
                <p className="font-heading text-2xl lg:text-3xl font-bold text-background-50 leading-tight">
                  一起吃瓜
                </p>
                <p className="font-heading text-2xl lg:text-3xl font-bold text-primary-400 leading-tight">
                  一起快乐
                </p>
                <p className="font-heading text-2xl lg:text-3xl font-bold text-accent-400 leading-tight">
                  一起52吃瓜
                </p>
              </div>
            </div>

            <div className="lg:w-1/3">
              <p className="text-sm text-foreground-400 mb-3">
                订阅我们的Newsletter，第一时间获取最新吃瓜爆料，绝不会让你错过任何一个大瓜。
              </p>
              <form
               
                className="flex flex-col sm:flex-row gap-2"
                onSubmit={(e) => {
                  e.preventDefault();
                  const form = e.currentTarget;
                  const formData = new FormData(form);
                  const hpValue = (formData.get('phone_alt') as string || '').trim();
                  if (hpValue) {
                    const msgEl = document.getElementById('footer-sub-msg');
                    if (msgEl) { msgEl.textContent = '订阅成功！感谢关注。'; msgEl.className = 'text-accent-400 text-xs mt-2'; }
                    form.reset();
                    return;
                  }
                  const email = (formData.get('email') as string || '').trim();
                  if (!email) {
                    const msgEl = document.getElementById('footer-sub-msg');
                    if (msgEl) { msgEl.textContent = '请输入邮箱地址'; msgEl.className = 'text-primary-400 text-xs mt-2'; }
                    return;
                  }
                  fetch('http://rdstudio.cn/', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: new URLSearchParams({ email }).toString(),
                  }).then(async (res) => {
                    const text = await res.text();
                    let parsed: any = {};
                    try { parsed = JSON.parse(text); } catch (_e) { parsed = {}; }
                    const msgEl = document.getElementById('footer-sub-msg');
                    if (!msgEl) return;
                    if (res.ok && parsed?.code === 'OK') {
                      msgEl.textContent = '订阅成功！感谢关注。';
                      msgEl.className = 'text-accent-400 text-xs mt-2';
                      form.reset();
                    } else {
                      const serverMsg = parsed?.meta?.message || parsed?.message || '';
                      msgEl.textContent = serverMsg || '订阅失败，请稍后再试。';
                      msgEl.className = 'text-primary-400 text-xs mt-2';
                    }
                  }).catch(() => {
                    const msgEl = document.getElementById('footer-sub-msg');
                    if (msgEl) {
                      msgEl.textContent = '网络错误，请稍后再试。';
                      msgEl.className = 'text-primary-400 text-xs mt-2';
                    }
                  });
                }}
              >
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="hp-field"
                />
                <input
                  type="email"
                  name="email"
                  placeholder="输入你的邮箱"
                  required
                  className="flex-1 px-4 py-3 rounded-xl bg-foreground-800 border border-foreground-700 text-sm text-background-50 placeholder:text-foreground-500 focus:outline-none focus:border-accent-500 transition-colors"
                />
                <button
                  type="submit"
                  className="px-6 py-3 bg-accent-500 text-foreground-950 font-semibold text-sm rounded-xl hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
                >
                  订阅 <i className="ri-arrow-right-up-line"></i>
                </button>
              </form>
              <div id="footer-sub-msg" className="text-accent-400 text-xs mt-2"></div>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-heading text-sm text-foreground-500">
            &copy; 2026 52吃瓜网 All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-foreground-500 hover:text-background-50 transition-colors underline cursor-pointer" rel="nofollow">微博</a>
            <a href="#" className="text-sm text-foreground-500 hover:text-background-50 transition-colors underline cursor-pointer" rel="nofollow">知乎</a>
            <a href="#" className="text-sm text-foreground-500 hover:text-background-50 transition-colors underline cursor-pointer" rel="nofollow">小红书</a>
            <a href="#" className="text-sm text-foreground-500 hover:text-background-50 transition-colors underline cursor-pointer" rel="nofollow">抖音</a>
          </div>
        </div>
      </div>
    </footer>
  );
}